import { StyledImageLogo } from '../TheWestHeader.styled'
import { createHeaderLogo, LogoProps } from './createHeaderLogo'

const logoFile = require('./images/masthead-manjimup-bridgetown-times.svg')

const props: LogoProps = {
    alt: 'Manjimup-Bridgetown Times',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
}

export default createHeaderLogo(StyledImageLogo, props)
